import React from "react";
import { ShieldAlert, Info } from "lucide-react";

const REVIEW_WARNING =
  "Guidelines must be reviewed and updated at least every 6–12 months against the latest SA NDoH STG/EML, ART, TB, hypertension, diabetes, and society guidelines.";
const DISCLAIMER =
  "This tool is for reference only and requires a qualified medical practitioner to approve any treatments.";

export default function GuidelineReviewNotice({ source }) {
  return (
    <div className="space-y-3 pt-2" data-testid="guideline-review-notice">
      <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-4 text-xs text-amber-900">
        <ShieldAlert className="w-4 h-4 mt-0.5 shrink-0 text-amber-600" />
        <span>{source ? `${source}. ` : ""}{REVIEW_WARNING}</span>
      </div>
      <div className="flex items-start gap-2 rounded-lg border border-slate-200 bg-slate-50 p-4 text-xs text-slate-600">
        <Info className="w-4 h-4 mt-0.5 shrink-0 text-slate-400" />
        <span>{DISCLAIMER}</span>
      </div>
    </div>
  );
}
